<cr-panel fxFlex>
	<cr-panel-header>
		<label>{{ translations?.SUBMITTED_TEXT_SECTION?.TITLE || 'submitted text' }}</label>
	</cr-panel-header>
	<cr-panel-actions>
		<cr-panel-action fxHide.lt-md>
			<div id="cr-hint-go-to-next-match"></div>
			<ng-container *ngTemplateOutlet="menu__next_match"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md>
			<ng-container *ngTemplateOutlet="menu__prev_match"></ng-container>
		</cr-panel-action>

		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__align_left"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__align_right"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__font_inc"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__font_dec"></ng-container>
		</cr-panel-action>
		<!--  -->
		<cr-panel-action fxHide.lt-md *ngIf="!AlertPreviewViewMode">
			<div id="cr-hint-toggle-content"></div>
			<ng-container *ngTemplateOutlet="menu__toggle_content"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="hasUrl">
			<ng-container *ngTemplateOutlet="menu__launch_url"></ng-container>
		</cr-panel-action>
		<!--  -->
		<cr-panel-action fxHide.gt-sm *ngIf="activeMediaQueries.includes('lt-md')">
			<button mat-button [matMenuTriggerFor]="appMenu" aria-label="More Options">
				<mat-icon svgIcon="more_vert"></mat-icon>
			</button>
		</cr-panel-action>
	</cr-panel-actions>

	<cr-panel-body fxLayout="column nowrap">
		<div fxFlex fxLayout="column" fxLayoutGap="1em">
			<div card fxFlex class="mat-elevation-z3" fxLayout="column">
				<!-- skeleton placeholder -->
				<ng-container *ngTemplateOutlet="!source ? skeleton__body : null"></ng-container>

				<!-- text for one-to-many -->
				<div
					[fxShow]="source && !(hasHtml && isHtml) && isOneToMany"
					crOriginalTextHelper
					[host]="this"
					text-container
					[ngStyle]="{ 'font-size': zoom + 'em' }"
					[dir]="direction">
					<ng-container *ngIf="textMatches; else clean">
						<ng-container *ngFor="let partial of textMatches[currentPage - 1]">
							<span *ngIf="partial.match.type === MatchType.none">{{ partial.content }}</span>
							<!--  -->
							<span
								*ngIf="partial.match.type !== MatchType.none && partial.match.type !== MatchType.excluded"
								[cr-match]="partial.match"
								origin="original">
								{{ partial.content }}
							</span>
							<!--  -->
							<i
								*ngIf="partial.match.type === MatchType.excluded && partial.match.reason != 8"
								[title]="EXCLUDE_MESSAGE[partial.match.reason]">
								{{ partial.content }}
							</i>
							<!--  -->
							<span
								*ngIf="partial.match.type === MatchType.excluded && partial.match.reason == 8"
								[cr-exclude-partial-scan]="partial.match"
								[title]="EXCLUDE_MESSAGE[partial.match.reason]">
								{{ partial.content }}
							</span>
						</ng-container>
					</ng-container>
				</div>

				<!-- text for one-to-one -->
				<div
					[fxShow]="source && !(hasHtml && isHtml) && !isOneToMany"
					crSourceTextHelper
					[host]="this"
					text-container
					[ngStyle]="{ 'font-size': zoom + 'em' }"
					[dir]="direction">
					<ng-container *ngIf="textMatches; else clean">
						<ng-container *ngFor="let partial of textMatches[currentPage - 1]">
							<span *ngIf="partial.match.type === MatchType.none">{{ partial.content }}</span>
							<span
								*ngIf="partial.match.type !== MatchType.none && partial.match.type !== MatchType.excluded"
								[cr-match]="partial.match"
								origin="source">
								{{ partial.content }}
							</span>
							<i
								*ngIf="partial.match.type === MatchType.excluded && partial.match.reason != 8"
								[title]="EXCLUDE_MESSAGE[partial.match.reason]">
								{{ partial.content }}
							</i>
							<span
								*ngIf="partial.match.type === MatchType.excluded && partial.match.reason == 8"
								[cr-exclude-partial-scan]="partial.match"
								[title]="EXCLUDE_MESSAGE[partial.match.reason]">
								{{ partial.content }}
							</span>
						</ng-container>
					</ng-container>
				</div>

				<!-- text without match highlighting -->
				<ng-template #clean>
					{{ source && (source.text.value | slice : pages[currentPage - 1] : pages[currentPage]) }}
				</ng-template>

				<!-- html for one-to-many -->
				<iframe
					sandbox="allow-scripts"
					title="Original Document"
					[fxShow]="hasHtml && isHtml && isOneToMany"
					cr-original-html-helper></iframe>

				<!-- html for one to one -->
				<iframe
					sandbox="allow-scripts"
					title="Source Document"
					[fxShow]="hasHtml && isHtml && !isOneToMany"
					cr-source-html-helper></iframe>
			</div>
		</div>

		<div content-footer fxLayout="row-reverse nowrap" fxLayoutAlign="space-between center">
			<cr-mat-pagination
				[currentPage]="currentPage"
				*ngIf="!(hasHtml && isHtml) && pages?.length !== 1"
				showFirstLastButtons
				(page)="onPage($event)"
				[totalPages]="pages?.length || 1"></cr-mat-pagination>

			<cr-powered-by *ngIf="!isOneToMany"></cr-powered-by>
		</div>
	</cr-panel-body>
</cr-panel>

<!-- menu -->
<mat-menu #appMenu>
	<div
		title="Open URL in a new tab"
		mat-menu-item
		*ngIf="hasUrl"
		(keyup.enter)="openUrl()"
		(click)="openUrl()"
		crClickStopPropagation>
		<!-- <ng-container *ngTemplateOutlet="menu__launch_url"></ng-container> -->
		<mat-icon svgIcon="launch"></mat-icon>
		{{ translations?.SHARED?.ACTIONS?.LAUNCH_URL || 'Open URL in a new tab' }}
	</div>
	<div
		mat-menu-item
		title="Next Match"
		[disabled]="
			(isHtml && (!htmlMatches || htmlMatches?.length === 0)) || (!isHtml && (!textMatches || textMatches.length === 0))
		"
		(click)="onJumpToNextMatchClick()"
		(keyup.enter)="onJumpToNextMatchClick()"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__next_match"></ng-container>
		{{ translations?.SHARED?.ACTIONS?.GO_TO_NEXT_MATCH || 'Next Match' }}
	</div>
	<div
		title="Previous Match"
		mat-menu-item
		[disabled]="
			(isHtml && (!htmlMatches || htmlMatches?.length === 0)) || (!isHtml && (!textMatches || textMatches.length === 0))
		"
		(click)="onJumpToNextMatchClick(false)"
		(keyup.enter)="onJumpToNextMatchClick(false)"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__prev_match"></ng-container>
		{{ translations?.SHARED?.ACTIONS?.GO_TO_PREV_MATCH || 'Previous Match' }}
	</div>
	<div
		title="Switch mode"
		mat-menu-item
		[disabled]="!hasHtml"
		(click)="toggleContent()"
		(keyup.enter)="toggleContent()"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__toggle_content"></ng-container>
		{{
			isHtml
				? translations?.SHARED?.ACTIONS?.SWITCH_TO_TEXTUAL_MODE || 'Switch to textual mode'
				: translations?.SHARED?.ACTIONS?.SWITCH_TO_RICH_TEXT_MODE || 'Switch to rich text mode'
		}}
	</div>
	<div
		title="Align Left"
		mat-menu-item
		*ngIf="!isHtml"
		(click)="changeTextAlign('ltr')"
		(keyup.enter)="changeTextAlign('ltr')"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__align_left"></ng-container>
		{{ translations?.SHARED?.ACTIONS?.ALIGN_LEFT || 'Align Left' }}
	</div>
	<div
		title="Align Right"
		mat-menu-item
		*ngIf="!isHtml"
		(click)="changeTextAlign('rtl')"
		(keyup.enter)="changeTextAlign('rtl')"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__align_right"></ng-container>
		{{ translations?.SHARED?.ACTIONS?.ALIGN_RIGHT || 'Align Right' }}
	</div>
	<div
		title="Increase Font Size"
		mat-menu-item
		*ngIf="!isHtml"
		(click)="increaseFontSize()"
		(keyup.enter)="increaseFontSize()"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__font_inc"></ng-container>
		{{ translations?.SHARED?.ACTIONS?.INCREASE_FONT_SIZE || 'Increase Font Size' }}
	</div>
	<div
		title="Decrease Font Size"
		mat-menu-item
		*ngIf="!isHtml"
		(click)="decreaseFontSize()"
		(keyup.enter)="decreaseFontSize()"
		crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__font_dec"></ng-container>
		{{ translations?.SHARED?.ACTIONS?.DECREASE_FONT_SIZE || 'Decrease Font Size' }}
	</div>
</mat-menu>

<ng-template #menu__launch_url>
	<button
		aria-label="Open URL in a new tab."
		title="Open URL in a new tab"
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.LAUNCH_URL || 'Open URL in a new tab'"
		(click)="openUrl()"
		crClickStopPropagation>
		<mat-icon svgIcon="launch"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__next_match>
	<button
		aria-label="Go to next match."
		title="Go to next match"
		mat-button
		(click)="onJumpToNextMatchClick()"
		[disabled]="
			(isHtml && (!htmlMatches || htmlMatches?.length === 0)) || (!isHtml && (!textMatches || textMatches.length === 0))
		"
		[matTooltip]="translations?.SHARED?.ACTIONS?.GO_TO_NEXT_MATCH || 'Go to next match'">
		<mat-icon svgIcon="arrow_downward"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__prev_match>
	<button
		aria-label="Go to previous match."
		title="Go to previous match"
		mat-button
		(click)="onJumpToNextMatchClick(false)"
		[disabled]="
			(isHtml && (!htmlMatches || htmlMatches?.length === 0)) || (!isHtml && (!textMatches || textMatches.length === 0))
		"
		[matTooltip]="translations?.SHARED?.ACTIONS?.GO_TO_PREV_MATCH || 'Go to previous match'">
		<mat-icon svgIcon="arrow_upward"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__toggle_content>
	<button
		aria-label="Switch report to text mode or rich text mode."
		mat-button
		*ngIf="!AlertPreviewViewMode"
		[matTooltip]="
			hasHtml
				? isHtml
					? translations?.SHARED?.ACTIONS?.SWITCH_TO_TEXTUAL_MODE || 'Switch to textual mode'
					: translations?.SHARED?.ACTIONS?.SWITCH_TO_RICH_TEXT_MODE || 'Switch to rich text mode'
				: 'No HTML version was found for this report'
		"
		[disabled]="!hasHtml"
		(click)="toggleContent()">
		<ng-container *ngIf="hasHtml">
			<mat-icon [svgIcon]="isHtml ? 'title' : 'insert_photo'"></mat-icon>
		</ng-container>
		<ng-container *ngIf="!hasHtml">
			<mat-icon>{{ isHtml ? 'title' : 'insert_photo' }}</mat-icon>
		</ng-container>
	</button>
</ng-template>
<ng-template #menu__align_left>
	<button
		aria-label="Align content to left."
		title="Align left"
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.ALIGN_LEFT || 'Align left'"
		(click)="changeTextAlign('ltr')">
		<mat-icon svgIcon="format_align_left"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__align_right>
	<button
		aria-label="Align content to right."
		title="Align right"
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.ALIGN_RIGHT || 'Align right'"
		(click)="changeTextAlign('rtl')">
		<mat-icon svgIcon="format_align_right"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__font_inc>
	<button
		aria-label="Increase font size."
		title="Increase font size"
		mat-button
		[matTooltip]="translations?.SHARED?.ACTIONS?.INCREASE_FONT_SIZE || 'Increase font size'"
		(click)="increaseFontSize()">
		<mat-icon svgIcon="zoom_in"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__font_dec>
	<button
		aria-label="Decrease font size."
		mat-button
		title="Decrease font size"
		[matTooltip]="translations?.SHARED?.ACTIONS?.DECREASE_FONT_SIZE || 'Decrease font size'"
		(click)="decreaseFontSize()">
		<mat-icon svgIcon="zoom_out"></mat-icon>
	</button>
</ng-template>

<!-- skeletons -->

<ng-template #skeleton__pagination>
	<div
		skeleton__pagination-wrapper
		fxLayout="row nowrap"
		fxLayoutGap="0.5em"
		fxLayoutAlign.lt-md="center stretch"
		fxLayoutAlign="start stretch">
		<ngx-skeleton-loader [theme]="{ width: '2em', height: '2em' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '2em', height: '2em' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader fxFlex [theme]="{ width: '100%', minWidth: '2em', height: '2em' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '2em', height: '2em' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '2em', height: '2em' }"></ngx-skeleton-loader>
	</div>
</ng-template>

<ng-template #skeleton__body>
	<div
		fxFlex
		fxLayout="column"
		fxLayoutAlign="start stretch"
		fxLayoutGap="1em"
		style="overflow: hidden; margin: 1em"
		skeleton__body>
		<ngx-skeleton-loader [theme]="{ height: '100%' }" *ngFor="let item of 20 | array"></ngx-skeleton-loader>
	</div>
</ng-template>
